import { render, staticRenderFns } from "./Banner2.vue?vue&type=template&id=e48cd770"
import script from "./Banner2.vue?vue&type=script&lang=js"
export * from "./Banner2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports